var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScreensharing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2075_571",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2075_571",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB4UlEQVR4nO3bQW4TQRSE4RJEJBLJCWCNOAqcA4kVce5CTsKGIwBZQa4QcQHk7P/IkhcR0kzGzkzP61J9+7Zel5/amp5nKSIiIiIiIiIiBJwBV8ANcE9t98AvYAOcdvP1AW+BW/r0Z1e/OunkXkN+HHbtzt4fFw4uVdn+THbwU5UBWzxsVRlGVBlGVBlGVBlGVBlGVBlGVBlGVBlGVBlGVBlGVBlGVBlGVNkM+7sDroEPwHvg9dp7KukZAf8FPgMna++hC0eG/A24WLv2rhwR8lfgxdp1d+fAkL8DL9euuUsHnsk5LhoE/WnkM84yEzJP0HdDRwaZCZm1o69HOvmWvrWZCZlYzMeBtVd4WH4mZGIh7wbW3uBh+ZmQiYWcD6zd4mH5mZApVTxnbS8SdCMJupEE3UiCbiRBN5KgG0nQjSRoo6CffLrLA8sMptxXjKy10SLozbFFYKRF0Kf7O9mDi8DI4kE/+ufsYNgJev7Ovtzdzf7/AzmyxoYqw4gqw4gqw4gqw4gqw4gqw4gqw4gqw4gqw4gqw4gqw4gqw4gqw4gqw4gqw4gqw2ds958qI4PozYLe4OGLKmPCi90O/AZeqTqeeLHbQchv1AtGXuwWtKvvx+646KKTIyIiIiIiIiK0vAdCD5623XFIVQAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreensharing);
export default __webpack_public_path__ + "static/media/Screensharing.8a52b5568b3b1ba7364ece041a7d53e5.svg";
export { ForwardRef as ReactComponent };